/**
 * Sporttia Copilot en el gestor. Copilot es otra aplicación: aquí solo se
 * carga su `widget.js`, que pinta el timón en un shadow root y abre el chat en
 * un iframe. El Manager nuevo (sporttia-manager) hace lo mismo en sus
 * secciones, con la misma regla, para que el timón no aparezca y desaparezca
 * al pasar de una aplicación a otra.
 */

/** Sirve `widget.js`. Copilot no tiene entorno de preproducción. */
export const COPILOT_BASE_URL = 'https://copilot.sporttia.com';

/**
 * Dónde pinta el timón `widget.js`: fijo abajo a la derecha, a 20 px de los
 * bordes y de 56 px. Lo decide Copilot; aquí solo se copia para que lo que
 * vive en esa esquina le deje sitio.
 */
export const COPILOT_LAUNCHER_OFFSET = 20;
export const COPILOT_LAUNCHER_SIZE = 56;

/** Atributo de `<html>` que activa la variante `copilot:` (src/index.css). */
export const COPILOT_LAUNCHER_ATTRIBUTE = 'data-copilot-launcher';

/**
 * Si el centro tiene Sporttia Copilot (ajuste por centro `copilotEnabled`).
 * Solo lo enciende un `true` booleano: un centro sin valor llega a `null`, y
 * un valor mal tipado no debe sacar el timón a quien no lo tiene.
 */
export function isCopilotEnabled(
    sc: { copilotEnabled?: unknown } | null | undefined,
): boolean {
    return sc?.copilotEnabled === true;
}
